/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRef, useState, useEffect } from 'react';

import {
  MoreIcon,
  PriceTagIcon,
  InvoiceSaleIcon,
  TrolleyICon,
  ChevronRightICon,
  CloseIcon
} from 'assets/img/icons/icons';
import './dropDownMore.css';

interface DropdownOption {
  id: string;
  label: string;
  icon: any;
  hasArrow?: boolean;
}

interface DropDownMoreItemsProps {
  setSelectedOption: any;
  selectedSalesValues?: any;
  setSelectedSalesValues?: any;
}

const DropDownMoreItems = ({
  setSelectedOption,
  selectedSalesValues,
  setSelectedSalesValues
}: DropDownMoreItemsProps) => {
  const [isOpenMore, setIsOpenMore] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const options: DropdownOption[] = [
    {
      id: 'discount-amount',
      label: 'Сумма скидки',
      icon: <InvoiceSaleIcon />,
      hasArrow: true
    },
    {
      id: 'discount-percent',
      label: 'Процентная скидка',
      icon: <PriceTagIcon />,
      hasArrow: true
    },
    {
      id: 'wholesale-price',
      label: 'Применить оптовую цену',
      icon: <TrolleyICon />,
      hasArrow: false
    }
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpenMore(false);
      }
    };

    if (isOpenMore) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpenMore]);

  const handleOptionClick = (optionId: string) => {
    setSelectedOption(optionId);
    setIsOpenMore(false);
    if (selectedSalesValues) {
      // Only add the new option without removing existing ones
      const existing = selectedSalesValues.find(
        (item: any) => item.name === optionId
      );
      if (!existing) {
        setSelectedSalesValues((prev: any) => [
          ...prev,
          {
            name: optionId,
            value: optionId === 'wholesale-price' ? true : null
          }
        ]);
      }
    }
    console.log(`Selected: ${optionId}`);
  };

  const handleRemoveDiscount = (optionId: string, e: React.MouseEvent) => {
    e.stopPropagation();
    if (setSelectedSalesValues) {
      setSelectedSalesValues((prev: any) =>
        prev.filter((item: any) => item.name !== optionId)
      );
    }
    setIsOpenMore(false);
  };

  const handleToggleClick = () => {
    setIsOpenMore(!isOpenMore);
  };

  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLButtonElement>
  ): void => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleToggleClick();
    } else if (event.key === 'Escape') {
      setIsOpenMore(false);
    }
  };

  const getDiscountValue = (optionId: string) => {
    const item = selectedSalesValues.find(
      (item: any) => item.name === optionId
    );
    return item?.value || null;
  };

  const isDiscountActive = (optionId: string) => {
    const item = selectedSalesValues.find(
      (item: any) => item.name === optionId
    );
    if (optionId === 'wholesale-price') {
      return item?.value === true;
    }
    return item?.value && (item.value as number) > 0;
  };

  const handleMenuKeyDown = (
    event: React.KeyboardEvent<HTMLButtonElement>,
    optionId: string
  ): void => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleOptionClick(optionId);
    }
  };

  return (
    <div className={`main-more-dropdown more-dropdown`} ref={dropdownRef}>
      <button
        className={`more-btn ${isOpenMore ? 'active' : ''}`}
        type="button"
        onClick={handleToggleClick}
        onKeyDown={handleKeyDown}
        aria-expanded={isOpenMore}
        aria-haspopup="true"
        aria-label="More options"
      >
        <div className="more-display">
          <MoreIcon />
        </div>
      </button>

      <ul
        className={`more-dropdown-menu more-menu ${isOpenMore ? 'show' : ''}`}
        role="menu"
      >
        {options.map((option, index) => {
          const discountValue = getDiscountValue(option.id);
          const isActive = isDiscountActive(option.id);
          return (
            <li key={option.id} role="none">
              <button
                onClick={() => handleOptionClick(option.id)}
                onKeyDown={e => handleMenuKeyDown(e, option.id)}
                className={`menu-item ${index === 0 ? 'first' : ''} ${
                  index === options.length - 1 ? 'last' : ''
                } ${isActive ? 'active-discount' : ''}`}
                role="menuitem"
                type="button"
              >
                <div className="menu-item-content">
                  {option.icon}
                  <div className="menu-label-container">
                    <span className="menu-label">{option.label}</span>
                    {isActive && discountValue !== null && (
                      <span className="discount-value">
                        {option.id === 'discount-percent'
                          ? `${discountValue}%`
                          : discountValue}
                      </span>
                    )}
                  </div>
                </div>
                {isActive ? (
                  <button
                    className="close-btn"
                    onClick={e => handleRemoveDiscount(option.id, e)}
                    aria-label={`Remove ${option.label}`}
                  >
                    <CloseIcon />
                  </button>
                ) : (
                  option.hasArrow && <ChevronRightICon />
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default DropDownMoreItems;
